<template>
  <div class="club_lamp_page">
    <div class="banner">
      <div class="banner-wrap flex-between">
        <div class="banner-item" v-for="(item, index) in images" :key="index">
          <div class="image">
            <img v-lazy="item.image" alt="">
          </div>
          <div class="text-wrap">
            <div class="text1">{{item.text1}}</div>
            <div class="text2">{{item.text2}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="buy-box flex" v-for="(item, index) in serverList" :key="index">
      <div class="logo">
        <img v-lazy="item.originalThumb" alt="">
      </div>
      <div class="info">
        <div class="title">{{item.title}}</div>
        <!-- <div class="subtitle">减少布线烦恼，提供自助开台服务</div> -->
        <div class="price">
          <span class="num">{{item.price}}</span>
          <span>元／件</span>
          <van-button round type="primary" class="buy-btn" @click="toBuy(item)">立即购买</van-button>
        </div>
      </div>
    </div>

    <div class="bcw buybar">
      <div class="buybar__content">
        <van-button type="primary" size="large" class="fs3" @click="scanCode">
          <i class="my-model__icon iconfont scan mrm">&#xe607;</i>
          <span>扫描设备二维码</span>
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import Vue from "vue";
import { Toast, Lazyload } from 'vant';
Vue.use(Toast).use(Lazyload);

export default {
  data() {
    return {
      images: [
        {
          image: 'https://static.ibuole.com/public_file/img/club_control.jpg',
          text1: '随时随地',
          text2: '掌握俱乐部动态'
        },
        {
          image: 'https://static.ibuole.com/public_file/img/club_training_rank.jpg',
          text1: '俱乐部排行榜',
          text2: '增加用户粘性'
        },
        {
          image: 'https://static.ibuole.com/public_file/img/club_table.jpg',
          text1: '自主开台',
          text2: '节省人力成本'
        },
        {
          image: 'https://static.ibuole.com/public_file/img/club_admin_table.jpg',
          text1: '自由掌控',
          text2: '开关之间尽显风采'
        }
      ],
      serverList: []
    }
  },
  methods: {
    toBuy(item) {
      this.$router.push('/buyLampSys?id='+ item.id)
    },
    scanCode() {
      // 扫一扫
      wx.scanQRCode({
        needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          console.log(res.resultStr); // 当needResult 为 1 时，扫码返回的结果
        }
      });
      // this.$router.push('/lampBindResult/0')
    },
    _getClubServers() {
      this.$http.post('product/getClubServiceList').then(res => {
        if(!res.data.code){
          this.serverList = res.data.value || []
        }else{
          Toast.fail(res.data.message)
        }
      })
    }
  },
  created() {
    this._getClubServers()
  }
}
</script>

<style lang='less'>
.club_lamp_page {
  padding-bottom: 80px;
  min-height: 100vh;
  background: #fff;
  .flex-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .flex-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .banner {
    padding: 30px 0;
    overflow-x: auto;
    .banner-wrap {
      padding: 0 20px;
      width: 980px;
      .banner-item {
        width: 220px;
        height: 380px;
        background: #56D176;
        border-radius: 10px;
        padding-top: 40px;
        box-shadow: 0 15px 30px 0 #aaa;
        .image {
          width: 130px;
          height: 260px;
          margin: 0 auto;
          img {
            width: 100%;
          }
        }
        .text-wrap {
          margin-top: 20px;
          padding: 0 30px;
          color: #fff;
          .text1 {
            font-size: 16px;
          }
          .text2 {
            font-size: 14px;
            text-align: right;
          }
        }
      }
    }
  }
  .buy-box {
    background: #fff;
    height: 100px;
    border-top: 1px solid #f0f0f0;
    .logo {
      width: 70px;
      height: 70px;
      margin: 15px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .info {
      .title {
        font-size: 17px;
        font-weight: 700;
        line-height: 2;
      }
      .price {
        .num {
          font-size: 20px;
          font-weight: 500;
          color: #56D176;
        }
      }
    }
    .buy-btn {
      height: 26px;
      line-height: 1;
      margin-left: 20px;
    }
  }
  .sao_btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 44px;
    background-color: #45AF60;
    color: #fff;
    font-size: 16px;
  }
}
@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
  .buybar {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
  // .club_lamp_page {
  //   padding-bottom: calc(70px+constant(safe-area-inset-bottom));
  //   padding-bottom: calc(70px+env(safe-area-inset-bottom));
  // }
}
</style>



// WEBPACK FOOTER //
// src/pages/clubAdmin/lampControl/index.vue